var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"box-cta td"},[_c('button',{staticClass:"button",on:{"click":function($event){return _vm.toggleModal(_vm.info, 'boxTd')}}},[_c('span',[_vm._v("Смотреть условия")]),_c('div',{staticClass:"button__icon"})])])}
var staticRenderFns = []

export { render, staticRenderFns }